import { ChangeDetectionStrategy, Component, Input, ViewChild, OnInit } from '@angular/core';

@Component({
  selector: 'gen-specimen-type',
  templateUrl: './specimen-type.component.html',
  styleUrls: ['./specimen-type.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class SpecimenTypeComponent implements OnInit {
  @Input() diagnosticOrder;
  @Input() specimenType;
  @Input() sampleType;
  @Input() collections;
  @Input() index;
  @Input() form;
  @Input() specimenTemplate;
  @Input() formId;
  @Input() editMode;
  @Input() formTitle;
  @Input() showBatchId;
  @Input() isSubmitted;

  public type: string;
  public idRegex: RegExp;
  public specimen;
  @ViewChild('specimenTypeForm') specimenTypeForm: HTMLElement;

  ngOnInit() {
    this.type = this.specimenTemplate ? this.specimenTemplate.toLowerCase() : this.specimenType.toLowerCase();
    this.idRegex = new RegExp('^[_a-zA-Z0-9:;.,!|/@()\u00AE\u2160\u2161\u2162\u2163\u2164\u2165\u2166\u2167\u2168\u2169\u03B1\u03B2<>"+=\\[\\]&-\\S]+$');
    this.specimen = this.diagnosticOrder.specimen[this.index];
    this.isType(this.type);
  }

  isType(type: string): boolean {
    return this.type.toLowerCase() === type;
  }

}
